<template>
<w-setting-sliding-popup ref="slidingPopup" :title="titleName" @close="onClosePopup" width="500px">
  <el-form slot="content" :model="eventColorInfo" :rules="rules" label-position="top" ref="eventlevelInfoForm">
    <el-row>
      <el-col :span="24">
        <el-form-item label="장애코드" prop="eventlevelId">
          <el-input :disabled='editField' v-model="eventColorInfo.eventlevelId"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="장애등급명" prop="eventlevelName">
          <el-input v-model="eventColorInfo.eventlevelName"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item label="배경 색상">
          <w-color-field ref="bgColorField" :value="selectColorBg" @input="changeBgColor"></w-color-field>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="폰트 색상">
          <w-color-field ref="fontColorField" :value="selectColorText" @input="changeFontColor"></w-color-field>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-form-item label="장애등급" prop="orderbyIndex">
          <el-input-number v-model="eventColorInfo.orderbyIndex" controls-position="right" :min="1"></el-input-number>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button class="mr-r4" size="large" type="solid" @click="saveEventLevel">저장</el-button>
    <el-button size="large" @click="onClosePopup">취소</el-button>
  </el-row>
</w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { clone } from 'lodash';
import isNil from 'lodash/isNil';
import eventlevelAPI from '@/api/model/eventlevel';
import WColorField from '@/components/form/ColorField';

export default {
  name: 'WEventlevelPopup',
  components: {
    WColorField,
  },
  props: {
    popupType: String,
    editRow: Object,
    eventlevelList: Array,
  },
  data() {
    return {
      formName: 'eventlevelInfoForm',
      selectColorBg: null,
      selectColorText: null,
      eventColorInfo: {
        eventlevelId: null,
        eventlevelName: null,
        orderbyIndex: null,
      },
      rules: {
        eventlevelId: [{
          required: true,
          trigger: 'blur',
          validator: this.validateForEventlevelId,
        }],
        eventlevelName: [{
          required: true,
          trigger: 'blur',
          validator: this.validateForEventlevelName,
        }],
      },
      dialogVisible: false,
      editField: false,
      titleName: '',
    };
  },
  watch: {
    editRow: {
      handler(row) {
        this.eventColorInfo = clone(row);
        if (this.popupType === 'ADD') {
          this.titleName = '이벤트 등급 추가';
          this.eventColorInfo.orderbyIndex = this.eventlevelList[this.eventlevelList.length - 1].orderbyIndex + 1;
          this.editField = false;
          // 이벤트 등급 추가 시 선택되어야 하는 default value
          this.selectColorBg = '#ffffff';
          this.selectColorText = '#000000';
        } else {
          this.titleName = `[${row.eventlevelName}] 정보`;
          this.editField = true;
          this.isSaved = true;
          this.selectColorBg = row.eventlevelColorBg;
          this.selectColorText = row.eventlevelColorText;
        }
      },
      immediate: true,
    },
  },
  methods: {
    onClosePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs[this.formName].clearValidate();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    saveEventLevel() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          const params = clone(this.eventColorInfo);
          params.eventlevelColorBg = this.selectColorBg;
          params.eventlevelColorText = this.selectColorText;
          const target = '이벤트 등급';
          let action;
          if (this.popupType === 'ADD') {
            action = msgUtil.action.ADD;
            eventlevelAPI.insertEventlevels(params).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload-data');
                this.onClosePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          } else {
            action = msgUtil.action.MODIFY;
            eventlevelAPI.updateEventlevels(params).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload-data');
                this.onClosePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('정보를 올바르게 설정해주십시오.'));
        }
      });
    },
    validateForEventlevelId(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다.'));
      } else if (value.length > 4) {
        callback('1~4자 문자를 입력해주십시오.');
      } else if (this.popupType === 'ADD') {
        eventlevelAPI.checkExistEventlevel(value).then((response) => {
          if (response.data.success) {
            if (response.data.data) {
              callback(new Error('이미 존재하는 이벤트 등급입니다.'));
            } else {
              callback();
            }
          } else {
            callback(new Error('이벤트 등급 중복 여부를 확인하지 못하였습니다.'));
          }
        }).catch(() => {
          callback(new Error('이벤트 등급 중복 여부를 확인하지 못하였습니다.'));
        });
      } else {
        callback();
      }
    },
    validateForEventlevelName(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다.'));
      } else if (value.length > 32) {
        callback('1~32자 문자를 입력해주십시오.');
      } else {
        callback();
      }
    },
    changeBgColor(bgColor) {
      this.selectColorBg = bgColor;
    },
    changeFontColor(fontColor) {
      this.selectColorText = fontColor;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/EventSettings/popup/EventlevelPopup.vue